import { Outlet } from "react-router-dom";
import { useState } from "react";
import { ModalContext } from "../context/ModalContext";
import { ReviewData } from "../component/ReviewData";
import Footer from "./Footer";
import Header from "./Header";
import "../css/layoutCom.css";

import close from "../img/review/close_popup_ico.png";
import arrow from "../img/review/arrow.png";

export default function LayoutCom() {
  // --- 모달 상태 및 로직 --- //
  const [modalBg, setModalBg] = useState(false);
  const [modalContent, setModalContent] = useState(null);

  const openReviewModal = (id) => {
    setModalContent(id);
    setModalBg(true);
    document.body.style.overflowY = "hidden";
  };

  const closeModal = () => {
    setModalBg(false);
    setModalContent(null);
    document.body.style.overflowY = "auto";
  };

  const renderModalContent = () => {
    if (!modalContent) return null;
    const currentItem = ReviewData.find((item) => item.id === modalContent);
    if (!currentItem) return null;

    return (
      <div className="Review_modal_content no-select">
        <div className="Review_modal_header">
          {}
          <h2 className="widTitle">{currentItem.title}</h2>
          <button onClick={closeModal}>
            <img src={close} alt="닫기" />
          </button>
        </div>
        <div className="Review_modal_inner">
          <div>
            <h2 className="mobTitle">{currentItem.title}</h2>
            <figure>
              <div>
                <img src={currentItem.image} alt="" />
                <h4>클라이언트 {currentItem.name}</h4>
              </div>
              <figcaption>{currentItem.longText}</figcaption>
            </figure>
          </div>

          <figure className="ProjectInfo">
            <span className="type">
              {currentItem.types.map((type, index) => (
                <img key={index} src={type} alt={type} />
              ))}
            </span>

            <figcaption>
              <p>
                플랫폼 : <span>{currentItem.os}</span>
              </p>
              <p>
                개발 종류 : <span>{currentItem.developmentType}</span>
              </p>
              <p>
                주요 기능 : <span>{currentItem.description}</span>
              </p>
            </figcaption>
          </figure>
        </div>
        <a className="link" href={currentItem.link}>
          결과물 보러가기 <img src={arrow} alt="결과물 보러가기" />
        </a>
      </div>
    );
  };

  return (
    <ModalContext.Provider value={{ openReviewModal }}>
      <div className="layoutCom">
        <Header />
        <Outlet />
        <Footer />

        {/* 모달 JSX를 최상위 레벨에서 렌더링 */}
        <div className={modalBg ? "Review_modal_wrap" : "blind"}>
          {renderModalContent()}
        </div>
      </div>
    </ModalContext.Provider>
  );
}
